<!-- main banner  -->
<div class="collab-banner sticky-header-banner banner-sec black-text">
    <div class="container">
        <div class="sec-padding m-col-width mt-negative">
           
            <div class="z-index pb-2">
                <div class="row mx-0 m-col-width">
                    <div class="col-md-6 col-sm-12 px-0 m-mb">
                        <div class="whats-new-label dark-banner">
                            <div class="wave-container">
                                <div class="wave-dot wave-dot-1"></div> 
                                <div class="wave-dot wave-dot-3"></div> 
                            </div> 
                            <span class="primary-color paragraph-global-text sub-head-paragraph">
                                {{'findAnsers.banner.findAnswers' | translate}}
                            </span>
                        </div>
        
                        <h1 class="banner-heading mw-700">{{'findAnsers.banner.headline1' | translate}} {{'findAnsers.banner.headline2' | translate}}</h1>
                        <p class="paragraph-global-text mw-500">{{'findAnsers.banner.subheadline' | translate}}</p>
                       <div class="my-3">
                            <a [href]="signUrl+'get-started/u/setup-profile?returnUrl=amy'" target="_blank">
                                <button class="save-btn cfa">
                                    {{'findAnsers.banner.ctaButtons.btnText' | translate}}
                                    <i class="pi pi-arrow-right title-color ml-2"></i>
                                </button>
                            </a>
                           <div class="mt-2 d-flex flex-column">
                                <p class="paragraph-global-text sub-head-paragraph mw-500 mb-0">
                                    {{'findAnsers.banner.ctaButtons.noCreditCard' | translate}}
                                </p>
                            </div>
                       </div>                      
                    </div>
                    <div class="col-md-6 col-sm-12 pr-0 d-flex align-items-center">
                        <figure>
                            <img class="w-100 pl-4" width="300" src="../../../assets/icons/find-answers/find-answer-banner.svg" alt="find answers">
                        </figure>
                    </div>
                </div>                
            </div>           
        </div>
    </div>
</div>


<!-- why find answers sec  -->
<div class="sec-padding why_find_Ans_sec">    
    <div class="container z-index">
        <div class="sec-title pb-3 mb-5 text-center">
            <div class="whats-new-label mx-auto">
                <div class="wave-container">
                    <div class="wave-dot wave-dot-1"></div> 
                    <div class="wave-dot wave-dot-3"></div> 
                </div> 
                <span class="primary-color paragraph-global-text sub-head-paragraph">
                    {{'findAnsers.whyFindAnswers.headingPre' | translate}}
                </span>
            </div>
            <h2 class="heading-one mx-auto">{{'findAnsers.whyFindAnswers.headline' | translate}} <br> {{'findAnsers.whyFindAnswers.headline2' | translate}}</h2>
            <p class="paragraph-global-text sub-head-paragraph">{{'findAnsers.whyFindAnswers.description' | translate}}</p>
        </div>
        <div class="row mx-0 m-col-width card-v-gap">
            <div class="col-md-4 col-sm-6 col-xs-12">
                <div class="card banner-cards justify-content-between">
                    <div>
                         <div class="rounded-img-bg p-3 mb-4 ml-0">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-search icon-primary-color"><circle cx="11" cy="11" r="8"></circle><path d="m21 21-4.3-4.3"></path></svg>
                         </div>
                         <h4 class="heading-three">{{'findAnsers.whyFindAnswers.general.title' | translate}}</h4>
                         <p class="paragraph-global-text sub-head-paragraph mw-300">{{'findAnsers.whyFindAnswers.general.description' | translate}}</p>
                    </div>
                </div>
             </div>
             <div class="col-md-4 col-sm-6 col-xs-12">
                 <div class="card banner-cards justify-content-between">
                      <div>
                        <div class="rounded-img-bg p-3 mb-4 ml-0">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-users icon-primary-color"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M22 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                         </div>
                          <h4 class="heading-three">{{'findAnsers.whyFindAnswers.hr.title' | translate}}</h4>
                          <p class="paragraph-global-text sub-head-paragraph mw-300">{{'findAnsers.whyFindAnswers.hr.description' | translate}}</p>
                      </div>
                 </div>
              </div>
             <div class="col-md-4 col-sm-6 col-xs-12">
                 <div class="card banner-cards justify-content-between">
                     <div>
                        <div class="rounded-img-bg p-3 mb-4 ml-0">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-headphones icon-primary-color"><path d="M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3"></path></svg>
                         </div>
                         <h4 class="heading-three">{{'findAnsers.whyFindAnswers.customerSupport.title' | translate}}</h4>
                         <p class="paragraph-global-text sub-head-paragraph mw-300">{{'findAnsers.whyFindAnswers.customerSupport.description' | translate}}</p>
                     </div>
                 </div>
             </div>    
             
             <div class="col-md-6 col-sm-12">
                <div class="card banner-bg-card card-hover-effect">
                    <img class="card-image" src=".././../../assets/icons/find-answers/why-find-answ-4.svg" alt="card-image">
                    <div class="card-content">
                        <h4 class="heading-three">{{'findAnsers.whyFindAnswers.marketing.title' | translate}}</h4>
                         <p class="paragraph-global-text sub-head-paragraph mw-400">{{'findAnsers.whyFindAnswers.marketing.description' | translate}}</p>
                    </div>
                </div>
             </div>
             <div class="col-md-6 col-sm-12">
                <div class="card banner-bg-card card-hover-effect">
                    <img class="card-image" src=".././../../assets/icons/find-answers/why-find-answ-4.svg" alt="card-image">
                    <div class="card-content">
                        <h4 class="heading-three">{{'findAnsers.whyFindAnswers.operations.title' | translate}}</h4>
                         <p class="paragraph-global-text sub-head-paragraph mw-400">{{'findAnsers.whyFindAnswers.operations.description' | translate}}</p>
                    </div>
                </div>
             </div>

             <div class="col-md-12 col-sm-12">
                <div class="card full-card card-hover-effect row mx-0 p-0">
                    <div class="col-md-6 col-sm-12 px-0 img-part">
                        <img class="card-image" src=".././../../assets/icons/find-answers/why-find-answ-6.svg" alt="card-image">
                    </div>
                    <div class="col-md-6 col-sm-12 px-0 content-part">
                        <div class="card-content">
                            <h4 class="heading-three">{{'findAnsers.whyFindAnswers.customerSuccess.title' | translate}}</h4>
                             <p class="paragraph-global-text sub-head-paragraph mw-400">{{'findAnsers.whyFindAnswers.customerSuccess.description' | translate}}</p>
                        </div>
                    </div>                   
                </div>
             </div>
        </div>
    </div>
</div>


<div class="scrollable-cards-container">
    <div *ngFor="let section of sections; let i = index" 
         class="card-section" 
         #cardSection
         [style.transform]="'translate3d(0px, ' + cardStates[i]?.translateY + 'px, 0px) scale3d(' + cardStates[i]?.scale + ', ' + cardStates[i]?.scale + ', 1)'"
         [style.opacity]="cardStates[i]?.opacity">
      <div class="card container">
        <div class="card-content">
          <div class="row card-v-gap">
            <div class="col-md-6 col-sm-12">
              <div class="h-100 d-flex flex-column justify-content-center">
                <div class="whats-new-label">
                    <div class="wave-container">
                        <div class="wave-dot wave-dot-1"></div> 
                        <div class="wave-dot wave-dot-3"></div> 
                    </div>
                    <span class="primary-color paragraph-global-text sub-head-paragraph">
                        {{section.pre}}
                    </span>
                </div>
                <h2 class="heading-one mw-450">
                  {{ section.title }} {{ section.title2 }}
                </h2>
                <p class="paragraph-global-text mw-500">{{ section.description }}</p>
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div class="image-content">
                <img [src]="section.imageUrl" [alt]="section.title">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>